import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { LoginVerificationChallenge } from 'src/app/models/login-verification-model/login-verification-challenge.model';
import { LoginVerificationContact } from 'src/app/models/login-verification-model/login-verification-contact.model';
import { UserService } from 'src/app/services/user-service/user.service';
import { UserStorageService } from 'src/app/services/user-storage-service/user-storage.service';

@Component({
  selector: 'app-login-verification-contact-card',
  templateUrl: './login-verification-contact-card.component.html',
  styleUrls: ['./login-verification-contact-card.component.scss']
})
export class LoginVerificationContactCardComponent implements OnInit, OnDestroy {

  public challenge: LoginVerificationChallenge;
  public errorMessage: string;
  public showButton = true;
  public selectedContact: LoginVerificationContact;
  private sendVerificationCodeSubscription: Subscription;

  constructor(private userService: UserService,
              private userStorageService: UserStorageService,
              private router: Router) { }

  ngOnInit() {
    this.challenge = this.userStorageService.getLoginVerificationChallenge();
    if (!this.challenge || !this.challenge.ChallengeId || !this.challenge.Contacts || this.challenge.Contacts.length === 0) {
      this.redirectToExpiredLogin();
    }
  }

  public sendVerificationCode() {
    this.errorMessage = null;
    if (!this.selectedContact) {
      this.errorMessage = 'signin-page.snackbar messages.empty verification contact';
      return;
    }

    this.showButton = false;
    this.sendVerificationCodeSubscription = this.userService.sendLoginVerificationCode(
      this.userStorageService.getLang(),
      this.userStorageService.getUDID(),
      this.challenge.ChallengeId,
      this.selectedContact.InternalId
    ).subscribe(
      (res) => {
        this.showButton = true;
        if (res && res['data'] && res['data']['success']) {
          this.router.navigate(['/signin/login-verification-code']);
        } else {
          this.errorMessage = 'signin-page.snackbar messages.verification code not sent';
        }
      },
      (error) => {
        this.showButton = true;
        this.errorMessage = this.resolveErrorMessage(error, 'signin-page.snackbar messages.verification code not sent');
      }
    );
  }

  public cancelVerification() {
    this.userStorageService.deleteLoginVerificationChallenge();
    this.router.navigate(['/signin']);
  }

  public selectContact(contact: LoginVerificationContact) {
    this.selectedContact = contact;
  }

  public isSelectedContact(contact: LoginVerificationContact) {
    return this.selectedContact && contact && this.selectedContact.InternalId === contact.InternalId;
  }

  public getContactIcon(contact: LoginVerificationContact) {
    if (contact && contact.Type === 'SMS') {
      return 'fas fa-mobile-alt';
    }
    return 'fas fa-envelope';
  }

  public isEmailContact(contact: LoginVerificationContact) {
    return contact && (contact.Type || '').toString().trim().toUpperCase() === 'EMAIL';
  }

  public getContactLabel(contact: LoginVerificationContact) {
    if (!contact || !contact.MaskedValue) {
      return '';
    }
    if (this.isEmailContact(contact)) {
      return contact.MaskedValue.toLowerCase();
    }
    return contact.MaskedValue;
  }

  private redirectToExpiredLogin() {
    this.userStorageService.deleteLoginVerificationChallenge();
    this.router.navigate(['/signin'], { queryParams: { loginVerificationExpired: true } });
  }

  private resolveErrorMessage(error, fallback) {
    if (error && error['error'] && error['error']['message']) {
      return error['error']['message'];
    }
    return fallback;
  }

  ngOnDestroy() {
    if (this.sendVerificationCodeSubscription) { this.sendVerificationCodeSubscription.unsubscribe(); }
  }
}
